<div class="header-bar" style="display: flex; justify-content: space-between">
  <h1>Expenses Report</h1>
  <div class="style2023 mt-2">
    <button
      *ngIf="isPOAD"
      type="button"
      pButton
      label="Back Fill"
      class="button-style btn-md ui-tertiary-button"
      (click)="backfillDialogVisible = true"
    ></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-file-download"
      label="Download"
      class="button-style btn-md ui-tertiary-button"
      (click)="downloadReport()"
      [disabled]="page.total == 0"
    ></button>
  </div>
</div>
<div class="">
  <div class="">
    <div class="">
      <div class="content-container style2023">
        <form #form="ngForm" (ngSubmit)="search()" style="width: 100%">
          <div
            class="filterPanel form-group"
            style="display: grid; grid-template-columns: repeat(6, 1fr); grid-gap: 25px"
          >
            <div class="input-group flex align-items-center" style="grid-column: span 2">
              <div class="input-group-prepend white-space-nowrap group-label">
                Job Closed Between
              </div>
              <div class="input-group-item flex-grow-1 white-space-nowrap justify-content-between">
                <i
                  class="fa fa-calendar mr-3 clickable-calendar-icon"
                  (click)="jobClosedBetweenCalendar.showOverlay()"
                ></i>
                <p-calendar
                  name="jobClosedBetween"
                  dateFormat="dd/mm/yy"
                  class="custom-calendar-template"
                  [selectionMode]="'range'"
                  [(ngModel)]="jobClosedBetweenSelection"
                  #jobClosedBetweenCalendar
                  (onSelect)="setJobClosedBetweenDates()"
                >
                </p-calendar>
              </div>
            </div>

            <div class="input-group flex align-items-center" style="grid-column: span 2">
              <div class="input-group-prepend white-space-nowrap group-label">
                Expense Completed Between
              </div>
              <div class="input-group-item flex-grow-1 white-space-nowrap justify-content-between">
                <i
                  class="fa fa-calendar mr-3 clickable-calendar-icon"
                  (click)="expensesCompletedBetweenCalendar.showOverlay()"
                ></i>
                <p-calendar
                  name="expenseCompletedBetween"
                  dateFormat="dd/mm/yy"
                  class="custom-calendar-template"
                  [selectionMode]="'range'"
                  [(ngModel)]="expenseCompletedBetweenSelection"
                  #expensesCompletedBetweenCalendar
                  (onSelect)="setExpenseCompletedBetweenDates()"
                >
                </p-calendar>
              </div>
            </div>

            <!--            <div class="input-group flex align-items-center" style="grid-column: span 2">-->
            <!--              <div class="input-group-prepend white-space-nowrap group-label">-->
            <!--                Expense Reviewed Between-->
            <!--              </div>-->
            <!--              <div class="input-group-item flex-grow-1 white-space-nowrap justify-content-between">-->
            <!--                <i-->
            <!--                  class="fa fa-calendar mr-3 clickable-calendar-icon"-->
            <!--                  (click)="expensesReviewedBetweenCalendar.showOverlay()"-->
            <!--                ></i>-->
            <!--                <p-calendar-->
            <!--                  name="expensesReviewedBetween"-->
            <!--                  dateFormat="dd/mm/yy"-->
            <!--                  class="custom-calendar-template"-->
            <!--                  [selectionMode]="'range'"-->
            <!--                  [(ngModel)]="expenseReviewedBetweenSelection"-->
            <!--                  #expensesReviewedBetweenCalendar-->
            <!--                  (onSelect)="setExpenseReviewedBetweenDates()"-->
            <!--                >-->
            <!--                </p-calendar>-->
            <!--              </div>-->
            <!--            </div>-->

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-multiSelect
                    [options]="statusOptions"
                    class="filter-dropdown input-group-filter"
                    [(ngModel)]="filterVal.filters.additionalChargeStatus.value"
                    name="reportSelectRequestUser"
                    defaultLabel="Select Status"
                  ></p-multiSelect>
                </div>
              </div>
            </div>

            <div></div>

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-multiSelect
                    [options]="chargeTypes"
                    class="filter-dropdown input-group-filter"
                    [(ngModel)]="filterVal.filters.expenseChargeTypes.value"
                    name="expenseChargeTypes"
                    defaultLabel="Select Expense Type"
                    [filter]="true"
                  ></p-multiSelect>
                </div>
              </div>
            </div>

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <input
                    pInputText
                    name="expenseAmount"
                    type="text"
                    style="width: 100%"
                    [(ngModel)]="filterVal.filters.expenseAmount.value"
                    pattern="^([0-9]+(\.?[0-9]?[0-9]?)?)$"
                    class="filter-input-container input-group-filter"
                    placeholder="Enter Amount (£)"
                  />
                </div>
              </div>
            </div>

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-multiSelect
                    [options]="declinedReasons"
                    class="filter-dropdown input-group-filter"
                    [(ngModel)]="filterVal.filters.declinedReasons.value"
                    name="declinedReasons"
                    defaultLabel="Select Declined Reason"
                  ></p-multiSelect>
                </div>
              </div>
            </div>

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-multiSelect
                    [options]="requestedUsers"
                    class="filter-dropdown input-group-filter"
                    [(ngModel)]="filterVal.filters.requestedUsers.value"
                    name="approvedUsers"
                    defaultLabel="Select Request User"
                  ></p-multiSelect>
                </div>
              </div>
            </div>

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-multiSelect
                    [options]="approvedDeclinedUsers"
                    class="filter-dropdown input-group-filter"
                    [(ngModel)]="filterVal.filters.approvedDeclinedUsers.value"
                    name="declinedUsers"
                    defaultLabel="Select Approve/Decline User"
                  ></p-multiSelect>
                </div>
              </div>
            </div>

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <input
                    pInputText
                    name="jobNumber"
                    type="text"
                    style="width: 100%"
                    [(ngModel)]="filterVal.filters.jobNumber.value"
                    class="filter-input-container input-group-filter"
                    placeholder="Job Number"
                  />
                </div>
              </div>
            </div>

            <div class="flex-grow-1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-multiSelect
                    [filter]="true"
                    [options]="supplierOptions"
                    class="filter-dropdown input-group-filter"
                    [(ngModel)]="filterVal.filters.suppliers.value"
                    name="suppliers"
                    defaultLabel="Select Suppliers"
                  ></p-multiSelect>
                </div>
              </div>
            </div>

            <div>
              <button
                pButton
                type="submit"
                label="Search"
                [disabled]="form.invalid"
                class="button-style btn-md ui-primary-button"
                icon="fa ui-icon-search"
              ></button>
              <button
                pButton
                type="button"
                icon="fa ui-icon-restore"
                class="button-style btn-md ui-tertiary-button ml-2"
                (click)="clearFilter(dt)"
              ></button>
            </div>
          </div>
        </form>

        <p-table
          #dt
          [value]="page.items"
          [lazy]="true"
          [rows]="20"
          [paginator]="true"
          rowHover="true"
          resizableColumns="true"
          [totalRecords]="page.total"
          (onLazyLoad)="onGridLazyLoad($event)"
          [hidden]="!isLoaded"
          [rowsPerPageOptions]="[20, 50, 100]"
          [pageLinks]="3"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 90px" pResizableColumn pSortableColumn="status">Status</th>
              <th style="width: 110px" pSortableColumn="JobClosedDateTime">Job Closed</th>
              <th style="width: 110px" class="" pResizableColumn pSortableColumn="jobRef">
                Job Ref.
              </th>
              <th style="width: 90px" class="" pResizableColumn pSortableColumn="vehicleReg">
                Vehicle Reg.
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="customerName">Customer</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="supplierName">Supplier</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="expenseType">
                Expense Type
              </th>
              <th style="width: 90px" pResizableColumn pSortableColumn="expenseChargeAmount">
                Amount
              </th>
              <th style="width: 90px" pResizableColumn pSortableColumn="requestInfoReason">
                Request Reason
              </th>
              <th style="width: 90px" pResizableColumn pSortableColumn="requestUser">
                Request User
              </th>
              <th style="width: 90px" pResizableColumn pSortableColumn="requestDate">
                Request Date
              </th>
              <th style="width: 100px" pResizableColumn pSortableColumn="declinedReason">
                Declined Reason
              </th>
              <th style="width: 90px" pSortableColumn="approvedDeclinedUser">
                Approved / Declined By
              </th>
              <th style="width: 90px" pSortableColumn="approvedDeclinedDate">
                Approved / Declined Date
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item">
              <td>{{ item.status }}</td>
              <td>{{ item.jobClosedDateTime | date : 'dd/MM/yyyy HH:mm' }}</td>
              <td (click)="navigateToJobScreen(item.jobId)" class="job-ref-clickable">
                {{ item.jobRef }}
              </td>
              <td>{{ item.vehicleReg }}</td>
              <td>{{ item.customerName }}</td>
              <td>{{ item.supplierName }}</td>
              <td>{{ item.expenseType }}</td>
              <td>{{ item.expenseChargeAmount }}</td>
              <td>{{ item.requestInfoReason }}</td>
              <td>{{ item.requestUser }}</td>
              <td>{{ item.requestDate | date : 'dd/MM/yyyy HH:mm' }}</td>
              <td>
                <span>{{ item.declinedReason }}</span>
              </td>
              <td>{{ item.approvedDeclinedByUser }}</td>
              <td>{{ item.approvedDeclinedDate | date : 'dd/MM/yyyy HH:mm' }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>

<p-dialog
  header="Backfill Report"
  [(visible)]="backfillDialogVisible"
  [style]="{ width: '500px' }"
  [modal]="true"
  [closable]="false"
>
  <div class="font-bold mb-2">Select From Date:</div>
  <p-calendar
    [(ngModel)]="backfillFromDate"
    [showIcon]="true"
    [showOnFocus]="true"
    [showTime]="false"
    [inline]="true"
    appendTo="body"
    dateFormat="dd/mm/yy"
  >
  </p-calendar>
  <p-footer>
    <div class="button-box">
      <button
        type="button"
        pButton
        label="Run"
        class="btn-to-right"
        [disabled]="!backfillFromDate || backfillRunning"
        (click)="backfillReport()"
      ></button>
      <button
        (click)="backfillDialogVisible = false"
        class="ui-button btn-to-right ui-button-tertiary"
        label="Cancel"
        pButton
        type="button"
      ></button>
    </div>
  </p-footer>
</p-dialog>
